
export const SchoolNews = {
  data () {
    return {
      currentPage: 1,
      limitPage: 15,
      totalPage: 0,
      newList: [],
      newListMobile: [],
      loading: true,
      total: 0,
      limitStart: 0
  }
  },
  mounted () {
    this.getData();
  },
  methods: {
    itemChange (current) {
      this.currentPage = current;
      this.getData();
    },
    // 点击新闻列表
    bindNewsItem (index) {
      // this.newList[index].isClick = true
      this.$router.push({
        name: 'SchoolNewsDetail',
        params: {
          id: index
        }
      })
    },
    getData () {
      this.loading = true;
      this.$http.get(this.$root.apiBaseUrl + '?g=api&m=api2&a=get_school_introduction_data&limit_start=' + this.limitStart + '&limit_end=' + this.limitPage).then(function (response) {
      if (response.body.status == 1) {
        this.newList = response.body.data.data;
        if(1 == this.currentPage) {
          this.newListMobile = response.body.data.data;
        } else {
          this.newListMobile = this.newListMobile.concat(this.newList);
        }
        this.total = parseInt(response.body.data.total);
        this.totalPage = Math.ceil(this.total/this.limitPage);
      }
      this.loading = false;
      }, function (reserror) {
        console.log(reserror);
      })
    }
  }
}

